// extracted by mini-css-extract-plugin
export default {"headerBar":"NewHospital_headerBar__sIY1z"};